import React from 'react';
import FilterCheckedCheckBox from 'src/assets/images/FilterCheckedCheckBox.svg';
import FilterUncheckedCheckBox from 'src/assets/images/FilterUncheckedCheckBox.svg';
import {
    CheckBoxWrapper,
    CheckboxLabel,
    CheckBoxImage,
} from './Checkbox.styled';

const Checkbox = ({
    label,
    onChange,
    checkedIcon,
    checkboxImageMargin,
    checkboxImageMobileMargin,
    checked,
    color,
    fontSize,
    padding,
    fontFamily,
    disabled,
    checkboxWrapperDisplay,
    marginTop,
    alignItemDirection,
    marginLeft,
    width,
    margin,
    fontWeight
}) => {
    return (
        <>
            <CheckBoxWrapper
                onClick={disabled ? () => {} : onChange}
                disabled={disabled}
                checkboxWrapperDisplay={checkboxWrapperDisplay}
                alignItemDirection={alignItemDirection}
                margin={margin}
            >
                {/* <CheckboxFormElement
                    type="checkbox"
                    value={value}
                    id={id}
                    name={name}
                    checked={checked}
                    onChange={() => {}}
                /> */}
                <CheckBoxImage
                    checkboxImageMargin={checkboxImageMargin}
                    checkboxImageMobileMargin={checkboxImageMobileMargin}
                    src={checked ? checkedIcon : FilterUncheckedCheckBox}
                    opacity={disabled ? 0.5 : 1}
                    width={width}
                ></CheckBoxImage>
                <CheckboxLabel
                    color={color}
                    fontSize={fontSize}
                    fontFamily={fontFamily}
                    padding={padding}
                    marginTop={marginTop}
                    marginLeft={marginLeft}
                    fontWeight={fontWeight}
                >
                    {label}
                </CheckboxLabel>
            </CheckBoxWrapper>
        </>
    );
};

Checkbox.defaultProps = {
    checkedIcon: FilterCheckedCheckBox,
    label: '',
    checkboxImageMargin: '0 11px 0 11.5px',
};

export default Checkbox;
